export function pluralize(count, noun, showCount = false) {
    return (showCount ? count : '') + ' ' + `${noun}${parseInt(count) > 1 ? 's' : ''}`;
}

export function numberToShortForm(num = 0) {
    return num.toLocaleString('en-US', {
        notation: 'compact',
        compactDisplay: 'short'
    });
}

export function sanitizeSlug(slug) {
    if (!slug) return false;
    return slug.replace(/[^a-zA-Z0-9-]/g, "");
};